import {ChangeDetectionStrategy, Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";

@Component({
    selector: "section-warehouse-order-pending-unilog-list",
    template: `
        <section-warehouse-order-list [state]="state" [status]="'pending_unilog'"
                                      header="Orders pending Unilog"></section-warehouse-order-list>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarehouseOrderPendingUnilogListComponent implements Base.IComponent {


    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "warehouse-orders-pending-unilog",
            actions: {
                "browse": ["browse_warehouse_orders"]
            }
        };
    }

}
